export default {
    setUser(state, payload) {
        state.user = {
            userId: payload.userId,
            name: payload.name,
            token: payload.token
        };
    },
    setAutoLogout(state) {
        state.didAutoLogout = true;
    }
};